import { CircleBlank, CircleCheck, Error } from '@gusto/workbench-icons';

const PasswordValidator = password => {
  const pass = password.password;
  const hasEightCharacters = pass.length >= 8;
  const hasOneLetter = /[a-zA-Z]/.test(pass);
  const hasOneNumber = /\d/.test(pass);
  const kale = { color: '#0A8080' };
  const error = { color: '#D5351F' };
  const salt800 = { color: '#3b3c41' };
  const hasEightCharactersStyle = hasEightCharacters ? kale : error;
  const hasOneLetterStyle = hasOneLetter ? kale : error;
  const hasOneNumberStyle = hasOneNumber ? kale : error;
  return (
    <div>
      <div>
        {pass === '' && <CircleBlank data-testid="circle-blank" fontSize="14px" />}
        {pass !== '' && hasEightCharacters && (
          <CircleCheck data-testid="circle-check-hasEightCharacters" color="kale.500" />
        )}
        {pass !== '' && !hasEightCharacters && <Error color="error.800" />}{' '}
        <span style={pass === '' ? salt800 : hasEightCharactersStyle} className="text-small">
          Use 8 or more characters.
        </span>
      </div>
      <div>
        {pass === '' && <CircleBlank fontSize="14px" />}
        {pass !== '' && hasOneLetter && <CircleCheck color="kale.500" />}
        {pass !== '' && !hasOneLetter && <Error color="error.800" />}{' '}
        <span
          data-testid="span-error-min-chars"
          style={pass === '' ? salt800 : hasOneLetterStyle}
          className="text-small"
        >
          {' '}
          Use a minimum of one letter.
        </span>
      </div>
      <div>
        {pass === '' && <CircleBlank fontSize="14px" />}
        {pass !== '' && hasOneNumber && (
          <CircleCheck data-testid="circle-check-hasOneNumber" color="kale.500" />
        )}
        {pass !== '' && !hasOneNumber && <Error color="error.800" />}{' '}
        <span
          data-testid="span-error-min-num"
          style={pass === '' ? salt800 : hasOneNumberStyle}
          className="text-small"
        >
          Use a minimum of one number.
        </span>
      </div>
    </div>
  );
};

export default PasswordValidator;
